import { languageInfo } from '../i18n/languages';

export const toLocaleByLanguage = (language?: string): string => languageInfo(language).intlLocale;

const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
const HAS_TIME_PATTERN = /T\d{2}:\d{2}/;
const HAS_TIMEZONE_PATTERN = /(Z|[+-]\d{2}:\d{2})$/i;

export const parseBackendDateToLocal = (rawDateString: string): Date | null => {
  try {
    const trimmed = rawDateString.trim();
    const normalized = trimmed.includes(' ') ? trimmed.replace(' ', 'T') : trimmed;

    // Keep date-only values stable in local timezone.
    if (DATE_ONLY_PATTERN.test(normalized)) {
      const [yearStr, monthStr, dayStr] = normalized.split('-');
      const year = Number(yearStr);
      const month = Number(monthStr);
      const day = Number(dayStr);
      const localDate = new Date(year, month - 1, day);
      return Number.isNaN(localDate.getTime()) ? null : localDate;
    }

    const hasTimezone = HAS_TIMEZONE_PATTERN.test(normalized);
    const hasTimePart = HAS_TIME_PATTERN.test(normalized);

    // Backend may send UTC timestamps without timezone suffix.
    // If time exists but zone is missing, treat as UTC by appending "Z".
    const parseTarget = hasTimePart && !hasTimezone ? `${normalized}Z` : normalized;
    const parsed = new Date(parseTarget);

    return Number.isNaN(parsed.getTime()) ? null : parsed;
  } catch {
    return null;
  }
};
